<template>
  <div>
      <b-table
        class="table b-table"
        :items="items"
        :fields="fields"
      >
        <template #cell(ver_detalles)="{ item }">
          <b-button
            variant="ligth"
            @click="$router.push(`/verificar-qr-aprobaciones/${item.ver_detalles}`)"
          >
            <font-awesome-icon :icon="['fas', 'info-circle']"/>
          </b-button>
        </template>
        <template #cell(estado)="{ item }">
          <span>{{fileStates.find(s => s.id === item.estado).value}}</span>
        </template>
      </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ApprovalExpedientView',
  data() {
    return {
      fields: [
        {
          key: 'numero',
          label: 'Número'
        },
        {
          key: 'nombre_unidad',
          label: 'Nombre Unidad'
        },
        {
          key: 'estado',
          label: 'Estado',
        },
        {
          key: 'fecha_creacion',
          label: 'Fecha creación',
        },
        {
          key: 'fecha_actualizacion',
          label: 'Fecha actualización',
        },
        {
          key: 'descripcion',
          label: 'Descripción',
        },
        {
          key: 'ver_detalles',
          label: 'Ver detalles',
        }
      ],
      fileStates: [
        { id: '1', value: 'Desestimado' },
        { id: '2', value: 'Preparado' },
        { id: '3', value: 'Iniciado' },
        { id: '4', value: 'Aprobado' },
        { id: '5', value: 'Rechazado' },
        { id: '6', value: 'Anulado' },
      ],
    };
  },
  created() {
    this.getApprovals();
  },
  methods: {
    ...mapActions('DocManagement', [
      'loadApprovals',
    ]),
    async getApprovals() {
      const id = this.getSelectedElement.documentId || this.getSelectedElement.id;
      const params = {
        orden: encodeURIComponent('-fechaCreacion'),
        filtros: `documentoId:${id}`,
        itemsPorPagina: 500,
        pagina: 1,
      };
      await this.loadApprovals(params);
    }
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getSelectedElement',
      'approvals'
    ]),
    items() {
      return this.approvals?.map((ap) => ({
        numero: ap.numero,
        nombre_unidad: ap.unidadNombre,
        estado: ap.aprobacionesEjecucionEstadoId,
        fecha_creacion: ap.fechaCreacion,
        fecha_actualizacion: ap.fechaActualizacion,
        descripcion: ap.descripcion,
        ver_detalles: ap.id,
      }));
    },
  },
  watch: {
    getSelectedElement() {
      this.getApprovals();
    },
  }
};
</script>

<style>

</style>
